"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_1 = require("@plq/is");
function default_1(key, initialValue, persist) {
    let initialPersist;
    try {
        initialPersist = persist ? JSON.parse(persist) : {};
    }
    catch (ignore) {
        initialPersist = {};
    } // eslint-disable-line no-empty
    let initialOrPersistedValue = (0, is_1.isFunction)(initialValue) ? initialValue() : initialValue;
    if (initialPersist && key in initialPersist) {
        initialOrPersistedValue = initialPersist[key] || initialOrPersistedValue;
    }
    return initialOrPersistedValue;
}
exports.default = default_1;
//# sourceMappingURL=get-persisted-value.js.map